import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type BSNState, type BSNActionTypes } from 'app/store/types';

const initialState: BSNState = {};

const bsnReducer = (state = initialState, action: BSNActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { bsn, bsnDevices, bsnAvailableDevices, bsnPolicyGroups, bsnDeviceOptions },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(bsn && { byId: bsn }),
					...(bsnDevices && { bsnDevicesById: bsnDevices }),
					...(bsnAvailableDevices && { bsnAvailableDevicesById: bsnAvailableDevices }),
					...(bsnPolicyGroups && { bsnPolicyGroupsById: bsnPolicyGroups }),
					...(bsnDeviceOptions && { bsnDeviceOptionsById: bsnDeviceOptions }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'bsn',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	bsnReducer,
);

// Selectors
export const getBSNById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) => bsn[selectedLicenseGroupId].byId;
export const getBsnDevicesById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) =>
	bsn[selectedLicenseGroupId].bsnDevicesById;
export const getBsnAvailableDevicesById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) =>
	bsn[selectedLicenseGroupId].bsnAvailableDevicesById;
export const getBsnPolicyGroupsById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) =>
	bsn[selectedLicenseGroupId].bsnPolicyGroupsById;
export const getBsnDeviceOptionsById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) =>
	bsn[selectedLicenseGroupId].bsnDeviceOptionsById;

export const getBSN = createSelector([getBSNById], (BSNById) => Object.values(BSNById));
export const getBsnDevices = createSelector([getBsnDevicesById], (BsnDevicesById) =>
	BsnDevicesById ? Object.values(BsnDevicesById) : [],
);
export const getBsnAvailableDevices = createSelector([getBsnAvailableDevicesById], (BsnAvailableDevicesById) =>
	BsnAvailableDevicesById ? Object.values(BsnAvailableDevicesById) : [],
);
export const getBsnPolicyGroups = createSelector([getBsnPolicyGroupsById], (BsnPolicyGroupsById) =>
	BsnPolicyGroupsById ? Object.values(BsnPolicyGroupsById) : [],
);
export const getBsnDeviceOptions = createSelector([getBsnDeviceOptionsById], (BsnDeviceOptionsById) =>
	BsnDeviceOptionsById ? Object.values(BsnDeviceOptionsById) : [],
);
